import { render, staticRenderFns } from "./tbc-records.vue?vue&type=template&id=087c51b4&scoped=true"
import script from "./tbc-records.vue?vue&type=script&lang=js"
export * from "./tbc-records.vue?vue&type=script&lang=js"
import style0 from "./tbc-records.vue?vue&type=style&index=0&id=087c51b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087c51b4",
  null
  
)

export default component.exports